@if (useCustomTemplate) {
  <div class="custom-dialog-container" [ngClass]="customContainerClass">
    @if (icon) {
      <span class="material-symbols-outlined custom-dialog-icon"
            [style.fontSize]="customIconSize"
            [style.color]="customIconColor">{{ icon }}</span>
    }

    <h2 class="custom-dialog-title">{{ title }}</h2>
    <p class="custom-dialog-message">{{ message }}</p>

    <div class="custom-dialog-actions">
      @if (showSecondaryButton) {
        <button type="button" class="efx-button-secondary button-secondary" (click)="decline()">{{ btnCancelText }}</button>
      }

      @if (showPrimaryButton) {
        <button type="button" class="efx-button-primary button-primary" (click)="accept()">{{ btnOkText }}</button>
      }
    </div>
  </div>
} @else {
  <div class="modal-header py-3" [ngClass]="{'justify-content-center': title === 'Borrar'}"
    style="border-bottom: none !important;">
    @if (title === 'Borrar') {
      <img src="assets/images/deleted_modal.svg" alt="Ícono de borrar" />
    }
    @if (title !== 'Borrar') {
      <h2 class="modal-title px-4">{{ title }}</h2>
    }
  </div>

  <div class="modal-body px-4 py-3" style="border-bottom: none !important;">

    @if (title === 'Borrar' || title === 'Contribución') {
      <h2 class="text-center">{{ message }}</h2>
      @if (subMessage && title !== 'Contribución' ) {
        <h6 class="text-center">{{ subMessage }}</h6>
      }
    }

    @if (title !== 'Borrar' && title !== 'Contribución') {
      <p [innerHtml]="message"></p>
    }

    @if (showComment) {
      <form class="my-3">
        <div>
          <label class="efx-label title" for="comment">{{ commentLabel }}@if (commentRequired) { <span class="text-danger">*</span> }</label>
          <textarea [(ngModel)]="text" name="comment" class="efx-textarea w-100" id="comment" cols="40"
          rows="3" [required]="commentRequired"></textarea>
        </div>
      </form>
    }
  </div>

  <div class="modal-footer px-4 py-3 gap-2" style="border-top: none !important;">
    @if (btnThirdText) {
      <button type="button" class="efx-button-secondary button-secondary" (click)="third()">{{ btnThirdText }}</button>
    }
    @if (title === 'Borrar' && btnThirdText) {
      <button type="button" class="efx-button-danger button-danger" (click)="decline()">{{ btnCancelText }}</button>
    }
    @if (title !== 'Borrar' || !btnThirdText) {
      <button type="button" class="efx-button-secondary button-secondary" (click)="decline()">{{ btnCancelText }}</button>
    }
    <button type="button" class="efx-button-primary button-primary" [disabled]="acceptDisabled" (click)="accept()">{{ btnOkText }}</button>
  </div>

  @if (mostrarPiepagina) {
    <div>
      <hr>
        @if (!showVIPUY) {
          <p class="text-left">
            <span style="float:left; padding-left: 13px;" class="material-symbols-outlined text-danger">info</span>
            <b style="float:left; padding-left: 4px;">La acción realizada será reflejada en los reportes en el transcurso de
              24
            horas.</b>
            <br>
            </p>
          } @else {
            <div class="px-4">
              <p class="fw-bold mb-1"><span class="text-danger">*</span> Recuerde que el retiro solo debe realizarse si se trató
              de un
            error.</p>
            <p class="fw-bold mb-1"><span class="text-danger">*</span> El costo se verá reflejado en la factura.</p>
            <p class="fw-bold mb-1"><span class="text-danger">*</span> La acción realizada será reflejada en los reportes en
            el
            transcurso de 24
          horas.</p>
        </div>
      }
    </div>
  }
}
